var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-auto" }, [
      _c("div", { staticClass: "sidebar" }, [
        _c(
          "a",
          {
            staticClass: "sidebar-item",
            class: { active: _vm.tab === "gegevens-wijzigen" },
            on: {
              click: function($event) {
                _vm.tab = "gegevens-wijzigen"
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 14 14",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M6.87106 7.57231C6.8202 7.52145 6.7499 7.49219 6.67774 7.49219C6.60582 7.49219 6.53528 7.52142 6.48442 7.57231C6.43358 7.62317 6.4043 7.69371 6.4043 7.76563C6.4043 7.83755 6.43356 7.90809 6.48442 7.95893C6.53528 8.00979 6.60582 8.03907 6.67774 8.03907C6.74965 8.03907 6.8202 8.00981 6.87106 7.95893C6.9219 7.90809 6.95118 7.83755 6.95118 7.76563C6.95118 7.69371 6.92192 7.62317 6.87106 7.57231Z"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M12.9609 5.96093H12.3016C11.9132 5.15286 11.0864 4.59375 10.1315 4.59375C9.17661 4.59375 8.34989 5.15288 7.96141 5.96093H1.03905C0.46611 5.96093 0 6.42707 0 6.99999C0 7.57293 0.466137 8.03904 1.03905 8.03904H5.42318C5.57418 8.03904 5.69662 7.91659 5.69662 7.7656C5.69662 7.6146 5.57418 7.49216 5.42318 7.49216H1.03905C0.767662 7.49216 0.546857 7.27135 0.546857 6.99996C0.546857 6.72857 0.767662 6.50776 1.03905 6.50776H7.77596C7.74279 6.66672 7.72526 6.83133 7.72526 6.99996C7.72526 8.32676 8.80471 9.40622 10.1315 9.40622C11.0864 9.40622 11.9132 8.84709 12.3016 8.03904H12.9609C13.5339 8.03904 14 7.5729 14 6.99999C14 6.42704 13.5339 5.96093 12.9609 5.96093ZM10.1315 8.85937C9.10629 8.85937 8.27215 8.02523 8.27215 6.99999C8.27215 5.97474 9.10629 5.14061 10.1315 5.14061C11.1568 5.14061 11.9909 5.97474 11.9909 6.99999C11.9909 8.02523 11.1568 8.85937 10.1315 8.85937ZM12.9609 7.49218H12.4871C12.5203 7.33323 12.5378 7.16862 12.5378 6.99999C12.5378 6.83136 12.5203 6.66672 12.4871 6.50779H12.9609C13.2323 6.50779 13.4531 6.7286 13.4531 6.99999C13.4531 7.27138 13.2323 7.49218 12.9609 7.49218Z"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M12.9609 10.5579H6.71678C6.32896 9.74811 5.50133 9.1875 4.54516 9.1875C3.58901 9.1875 2.76136 9.74814 2.37353 10.5579H1.03905C0.46611 10.5579 0 11.024 0 11.5969C0 12.1699 0.466137 12.636 1.03905 12.636H2.37651C2.76562 13.4423 3.59147 14 4.54513 14C5.49876 14 6.32464 13.4423 6.71375 12.636H12.9609C13.5339 12.636 14 12.1699 14 11.597C14 11.024 13.5339 10.5579 12.9609 10.5579ZM1.03905 12.0891C0.767662 12.0891 0.546857 11.8683 0.546857 11.5969C0.546857 11.3255 0.767662 11.1047 1.03905 11.1047H2.18888C2.15615 11.2627 2.13889 11.4262 2.13889 11.5937C2.13889 11.7635 2.15667 11.9292 2.19027 12.0891H1.03905ZM4.54516 13.4531C3.51991 13.4531 2.68578 12.619 2.68578 11.5937C2.68578 10.5685 3.51991 9.73436 4.54516 9.73436C5.5704 9.73436 6.40454 10.5685 6.40454 11.5937C6.40454 12.619 5.5704 13.4531 4.54516 13.4531ZM12.9609 12.0891H6.90002C6.93362 11.9292 6.9514 11.7635 6.9514 11.5937C6.9514 11.4262 6.93414 11.2627 6.90141 11.1047H12.9609C13.2323 11.1047 13.4531 11.3255 13.4531 11.5969C13.4531 11.8683 13.2323 12.0891 12.9609 12.0891Z"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M9.73627 1.44731C9.68544 1.39645 9.61489 1.36719 9.54297 1.36719C9.47106 1.36719 9.40051 1.39642 9.34965 1.44731C9.29879 1.49819 9.26953 1.56871 9.26953 1.64063C9.26953 1.71255 9.29876 1.78309 9.34965 1.83393C9.40051 1.88481 9.47106 1.91407 9.54297 1.91407C9.61489 1.91407 9.68544 1.88481 9.73627 1.83393C9.78713 1.78309 9.81642 1.71255 9.81642 1.64063C9.81642 1.56871 9.78716 1.49817 9.73627 1.44731Z"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M12.9609 1.36718H10.541C10.39 1.36718 10.2675 1.48963 10.2675 1.64063C10.2675 1.79162 10.39 1.91407 10.541 1.91407H12.9609C13.2323 1.91407 13.4531 2.13487 13.4531 2.40627C13.4531 2.67766 13.2323 2.89846 12.9609 2.89846H6.90073C6.9339 2.73951 6.95142 2.5749 6.95142 2.40627C6.95142 2.23763 6.9339 2.07299 6.90073 1.91407H8.39454C8.54554 1.91407 8.66798 1.79162 8.66798 1.64063C8.66798 1.48963 8.54554 1.36718 8.39454 1.36718H6.71528C6.3268 0.559135 5.50005 0 4.54516 0C3.59027 0 2.76352 0.559135 2.37504 1.36718H1.03905C0.46611 1.36718 0 1.83332 0 2.40624C0 2.97918 0.466137 3.44529 1.03905 3.44529H2.37501C2.76349 4.25337 3.59022 4.81248 4.54513 4.81248C5.50005 4.81248 6.32677 4.25334 6.71525 3.44529H12.9609C13.5339 3.44529 14 2.97915 14 2.40624C14 1.83332 13.5339 1.36718 12.9609 1.36718ZM2.18956 2.89843H1.03905C0.767662 2.89843 0.546857 2.67763 0.546857 2.40624C0.546857 2.13485 0.767662 1.91404 1.03905 1.91404H2.18956C2.15639 2.07299 2.13887 2.23761 2.13887 2.40624C2.13887 2.5749 2.15639 2.73951 2.18956 2.89843ZM4.54516 4.26565C3.51991 4.26565 2.68578 3.43151 2.68578 2.40627C2.68578 1.38099 3.51986 0.546885 4.54516 0.546885C5.5704 0.546885 6.40454 1.38102 6.40454 2.40627C6.40454 3.43151 5.5704 4.26565 4.54516 4.26565Z"
                  }
                })
              ]
            ),
            _vm._v("\n        Gegevens wijzigen\n      ")
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col" },
      [
        _vm.tab === "gegevens-wijzigen"
          ? _c("gegevens-wijzigen", {
              attrs: { expert: _vm.expert, ajax: _vm.ajax }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/MijnAccount.vue?vue&type=template&id=470902a9&
// module id = 427
// module chunks = 0